import React from "react"
import { css } from "styled-components"
import Breakpoints from "../../../components/shared/breakpoints"
import { Block, Spacer } from "../../atoms/layout-primitives"
import { BlogGrid } from "../../atoms/layout-primitives/grid"
import Breadcrumbs from "../../molecules/breadcrumbs"

interface IListingBreadcrumbsProps {
  children: any
}

/**
 * Template for a listing page's breadcrumbs
 * @param children - the breadcrumbs
 */
const ListingBreadcrumbs = ({ children: crumbs }: IListingBreadcrumbsProps) => {
  return (
    <BlogGrid>
      <Block>
        <Spacer height={{ sm: "16px", lg: "32px" }} />
        <Breadcrumbs>{crumbs}</Breadcrumbs>
        <Spacer height={{ sm: "8px", md: "16px" }} />
      </Block>
    </BlogGrid>
  )
}

export default ListingBreadcrumbs
